/**
 * Shared auth/session failure helpers for API calls.
 * Session can expire while the SPA stays mounted (GoogleAuthGate only checks on load).
 */

export const AUTH_EXPIRED_EVENT = 'cockpit:auth-expired';

export const GENERIC_SAVE_MSG =
  'Could not save to the server. Changes are only on this device until reconnect.';

export const SESSION_EXPIRED_SAVE_MSG =
  'Session expired. Sign in again to save — edits stay on this device until then.';

export const SESSION_EXPIRED_DOCS_MSG =
  'Session expired — sign in again to load documents.';

export function isAuthFailureStatus(status) {
  return status === 401 || status === 403;
}

export function persistErrorMessage(status) {
  return isAuthFailureStatus(status) ? SESSION_EXPIRED_SAVE_MSG : GENERIC_SAVE_MSG;
}

export function notifyAuthExpired() {
  if (typeof window === 'undefined') return;
  try {
    window.dispatchEvent(new CustomEvent(AUTH_EXPIRED_EVENT));
  } catch {
    /* ignore */
  }
}

export function authLoginUrl(apiBase) {
  return `${apiBase}/api/auth/login`;
}
